module.exports = __webpack_public_path__ + "media/images/img-griffin-66dd3ac7247607bfd3f932da040d5907.png";